import SkipNextButton from './SkipNextButton';

export default SkipNextButton;
